<template>
  <v-card
    class="pa-5"
    data-aos="fade-up"
    width="100%"
  >
    <v-container fill-height>
      <v-row>
        <v-col>
          <v-btn
            block
            color="primary"
            large
            rounded
            depressed
            @click="$emit('add')"
          >
            Add Dependent
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  export default {
    name: 'DependentCard'
  }
</script>

<style lang="scss" scoped>

</style>